import React, { useState } from 'react';
import PropTypes from 'prop-types';
import KeyStore from 'utils/KeyStore';
import { makeStyles } from '@material-ui/core';
import PayrollBaseList from 'components/modules/payroll/read/PayrollBaseList';
import DealCommissionTable from 'components/widgets/payroll/MiscCommissions/DealCommissionTable';
import GeneralCommissionPanel from 'components/widgets/payroll/MiscCommissions/GeneralCommissionTable';
import DealPaidCommissionTable from 'components/widgets/payroll/MiscCommissions/DealPaidCommissionTable';
import PurchasingAgentCommissionTable from 'components/widgets/payroll/MiscCommissions/PurchasingAgentCommissionTable';

const useStyles = makeStyles(() => ({
    defaultText: {
        height: '100%',
        textAlign: 'center',
        alignContent: 'center',
    },
}));

const MiscCommissionList = () => {
    const classes = useStyles();
    const keyStore = new KeyStore();
    const savedSizes = keyStore.getMiscCommissionSplitSize() || [50, 50];
    const [displayPaidOnlySwitch, setDisplayPaidOnlySwitch] = useState(false);

    const onResizingSplit = (size) => {
        keyStore.setMiscCommissionSplitSize(size);
    };

    const getRightSideComponent = ({
        employeeId, payPeriod, employeeType, displayPaidCommissions, payPeriodYear,
    }) => {
        const isGeneralCommissions = employeeType.toUpperCase().includes('GENERAL');
        const isPurchasingAgentCommissions = employeeType.toUpperCase().includes('PURCHASING');
        const displayPanel = employeeId > 0 && Boolean(payPeriod);
        const displayDealCommissions = !isGeneralCommissions && !isPurchasingAgentCommissions && displayPanel;
        setDisplayPaidOnlySwitch(displayDealCommissions);

        return (
            <div>
                {!displayPanel && (
                    <div className={classes.defaultText}>No display Available</div>
                )}
                {displayDealCommissions && !displayPaidCommissions && (
                    <DealCommissionTable
                        payPeriod={payPeriod}
                        employeeId={employeeId}
                    />
                )}
                {displayDealCommissions && displayPaidCommissions && (
                    <DealPaidCommissionTable
                        employeeId={employeeId}
                        year={payPeriodYear}
                    />
                )}
                {displayPanel && isGeneralCommissions && (
                    <GeneralCommissionPanel
                        payPeriod={payPeriod}
                        employeeId={employeeId}
                    />
                )}
                {displayPanel && isPurchasingAgentCommissions && (
                    <PurchasingAgentCommissionTable
                        payPeriod={payPeriod}
                        employeeId={employeeId}
                    />
                )}
            </div>
        );
    };

    getRightSideComponent.propTypes = {
        payPeriod: PropTypes.string.isRequired,
        employeeId: PropTypes.number.isRequired,
        employeeType: PropTypes.string.isRequired,
        payPeriodYear: PropTypes.number.isRequired,
        displayPaidCommissions: PropTypes.bool.isRequired,
    };

    return (
        <PayrollBaseList
            commissionOnly
            splitSize={savedSizes}
            onResizingSplit={onResizingSplit}
            displayPaidOnlySwitch={displayPaidOnlySwitch}
            getRightSideComponent={getRightSideComponent}
        />
    );
};

export default MiscCommissionList;
